import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { module } from 'modujs'

gsap.registerPlugin(ScrollTrigger)

export default class extends module {
  constructor(m) {
    super(m)

    this.events = { click: { loadMore: 'loadMore' } }
  }

  init() {
    this.cardsPerLoad = 8
    this.currentPage = 1
    this.currentFilteredCards = []

    this.filtersWrapperEl = this.el.querySelector('.filter-btn')
    this.moreBtnEl = this.el.querySelector('.news-list__right__btn')
    this.cardsWrapper = this.el.querySelector('.news-list__cards')
    this.cards = [...this.el.querySelectorAll('.news-card')]
    this.maxPage = Math.ceil(this.cards.length / this.cardsPerLoad)
    this.maxPageFiltered = Math.ceil(this.currentFilteredCards.length / this.cardsPerLoad)

    this.mm = window.matchMedia('(width > 700px)')

    if (this.filtersWrapperEl) {
      this.sc = ScrollTrigger.create({
        trigger: this.filtersWrapperEl,
        start: 'top 10%',
        endTrigger: this.cardsWrapper,
        end: 'bottom top+=20%',
        pin: true,
        onLeave: () => {
          this.filtersWrapperEl.$module?.closeFilters()
        }
      })
    }
  }

  filter(tagID = 'all') {
    this.currentPage = 1

    const filteredCards = this.cards.filter((card) => {
      if (tagID === 'all')
        return true

      const tags = card.dataset.tags?.split(',')

      return tags?.includes(tagID)
    })

    this.currentFilteredCards = tagID === 'all'
      ? []
      : filteredCards
    this.maxPageFiltered = Math.ceil(this.currentFilteredCards.length / this.cardsPerLoad)

    this.call(
      'scrollTo',
      this.mm.matches
        ? '.news-list'
        : 0,
      'Scroll'
    )

    const tl = gsap.timeline({ onComplete: () => {
      this.call('onFinishedFiltering', 'FilterBtn')
    } })
    const firstPageToShow = filteredCards.slice(0, this.cardsPerLoad)

    tl.to(this.cards, {
      opacity: 0,
      duration: 0.2,
      scale: 0.9,
      ease: 'power4.in',
      display: 'none',
      clearProps: 'opacity,scale'
    })
      .call(() => {
        this.cards.forEach(card => card.classList.remove('filtered', 'active'))

        if (tagID !== 'all') {
          filteredCards.forEach(card => card.classList.add('filtered'))
        }

        this.cardsWrapper.classList.toggle('is-filtered', tagID !== 'all')

        this.moreBtnEl.classList.toggle('hidden', filteredCards.length <= this.cardsPerLoad)
      })
      .fromTo(
        firstPageToShow,
        {
          opacity: 0,
          scale: 1.1,
          display: 'none'
        },
        {
          opacity: 1,
          scale: 1,
          duration: 0.4,
          ease: 'power4.out',
          display: 'block',
          stagger: { amount: 0.4 },
          delay: 0.2,
          immediateRender: false,
          clearProps: 'opacity,scale'
        }
      )
  }

  loadMore() {
    const isFiltered = this.cardsWrapper.classList.contains('is-filtered')

    if ((isFiltered && this.currentPage === this.maxPageFiltered) || (!isFiltered && this.currentPage === this.maxPage))
      return

    const cards = isFiltered
      ? this.currentFilteredCards
      : this.cards

    for (let i = this.currentPage * this.cardsPerLoad; i < this.currentPage * this.cardsPerLoad + this.cardsPerLoad; i++) {
      if (cards[i])
        cards[i].classList.add('active')
    }

    this.currentPage++

    ScrollTrigger.refresh()

    if ((isFiltered && this.currentPage === this.maxPageFiltered) || (!isFiltered && this.currentPage === this.maxPage))
      this.moreBtnEl.classList.add('hidden')
  }

  destroy() {
    this.sc?.kill()
  }
}
